// extracted by mini-css-extract-plugin
export var cardIcon = "_4q-4";
export var checkboxCard = "_4q-0";
export var checkboxCardSelected = "_4q-1";
export var disabled = "_4q-2";
export var outerBorder = "_4q-3";
export var spacerMedium = "_4q-7";
export var spacerSmall = "_4q-6";
export var spacerXsmall = "_4q-5";